import MoveWizardStep3 from './move-wizard-step-3';
export default MoveWizardStep3;
